import { c as _c } from "react/compiler-runtime";
import { isUsTaxId, isUsTaxIdSandbox } from '@onefootprint/core';
import type { FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormInput, { type FormInputProps } from './form-input';
export type FormUsTaxIdProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
  /**
   * In sandbox mode, relax validation to accept the `000`/`666` SSN9 area prefixes used for test
   * data. The backend allows these in sandbox, so the FE must not block them.
   */
  useLenientValidation?: boolean;
} & Omit<FormInputProps<TFieldValues>, 'name' | 'rules' | 'type' | 'autoComplete' | 'placeholder'>;
export default function FormUsTaxId(t0) {
  const $ = _c(14);
  let props;
  let rules;
  let t1;
  if ($[0] !== t0) {
    ({
      rules,
      useLenientValidation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = rules;
    $[3] = t1;
  } else {
    props = $[1];
    rules = $[2];
    t1 = $[3];
  }
  const useLenientValidation = t1 === undefined ? false : t1;
  const {
    t
  } = useTranslation("ui");
  let t2;
  if ($[4] !== t || $[5] !== useLenientValidation) {
    t2 = value => {
      if (!value) {
        return true;
      }
      const digits = value.replace(/-/g, "");
      if (digits.length !== 9) {
        return t(_temp);
      }
      const isValid = useLenientValidation ? isUsTaxIdSandbox(value) : isUsTaxId(value);
      if (!isValid) {
        return t(_temp2);
      }
      return true;
    };
    $[4] = t;
    $[5] = useLenientValidation;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== rules || $[8] !== t2) {
    t3 = {
      validate: t2,
      ...rules
    };
    $[7] = rules;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const usTaxIdRules = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      numericOnly: true,
      delimiters: ["-", "-"],
      blocks: [3, 2, 4]
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props || $[12] !== usTaxIdRules) {
    t5 = <FormInput {...props} rules={usTaxIdRules} type="tel" autoComplete="off" mask={t4} placeholder="XXX-XX-XXXX" />;
    $[11] = props;
    $[12] = usTaxIdRules;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp2($_0) {
  return $_0.components.form["us-tax-id"].errors.invalid;
}
function _temp($) {
  return $.components.form["us-tax-id"].errors["invalid-length"];
}